const actions = {
  ADD_OP: 'ADD_OP',
  GET_OPS: 'GET_OPS',
  GET_OP: 'GET_OP',
  SET_OPS: 'SET_OPS',
  EDIT_OPS: 'EDIT_OPS',
  DELETE_OP: 'DELETE_OP',
  DELETED_OP: 'DELETED_OP',
  PASS_OPTIONS: 'PASS_OPTIONS',
  SET_PAGINATION_OPS: 'SET_PAGINATION_OPS',
  ADD_NOTAS_PRODUCCION: 'ADD_NOTAS_PRODUCCION',
  UPDATE_ETAPA: 'UPDATE_ETAPA',
  SET_OPERARIO: 'SET_OPERARIO',
  SET_PERMISOS_OPERARIO: 'SET_PERMISOS_OPERARIO',
  CONFIRMAR_INVENTARIO:'CONFIRMAR_INVENTARIO',
  UPDATE_OP_ESTADO:'UPDATE_OP_ESTADO',
  newOp: data => ({ type: actions.ADD_OP, data }),
  getOp: data => ({ type: actions.GET_OP, data }),
  getOps: query =>({ type: actions.GET_OPS, query }),
  editOps: (data, query) =>({ type: actions.EDIT_OPS, data, query }),
  deleteOP: id =>({ type: actions.DELETE_OP, id }),
  passToOptions: (data, accion) =>({ type: actions.PASS_OPTIONS, data, accion }),
  addNotasProduccion: (id, data) =>({ type: actions.ADD_NOTAS_PRODUCCION, id, data }),
  confirmInventarioOP: ( data)  =>({ type: actions.CONFIRMAR_INVENTARIO, data }),
};
export default actions;
